// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cepp__textarea[data-v-6b3c8bc2]{height:125px}.cepp__textarea_header[data-v-6b3c8bc2]{font-size:21px;font-weight:bolder}\n", ""]);
// Exports
module.exports = exports;
